'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import { ARTICLE_LIKE_ROUTE_SEGMENTS } from '@/utils/get-content-type';
import { promoBlockVariantMap } from './const';
import { PromoBlockProps } from './types';

const PromoBlock: React.FC<PromoBlockProps> = (props) => {
  const pathname = usePathname();
  const PromoBlockComponent = promoBlockVariantMap[
    props.variant
  ] as React.FC<PromoBlockProps>;

  if (!PromoBlockComponent) return null;

  const content = <PromoBlockComponent {...(props as PromoBlockProps)} />;
  const useArticleLayout = ARTICLE_LIKE_ROUTE_SEGMENTS.some((segment) =>
    pathname?.includes(`/${segment}/`),
  );

  if (props.variant === 'floating') return content;
  if (useArticleLayout) {
    return (
      <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
        <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11">
          {content}
        </div>
      </div>
    );
  }

  return <div className="container mx-auto px-4 sm:px-0">{content}</div>;
};

export default PromoBlock;
